import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { ChevronDown } from "react-ikonate";

import styles from "./Select.module.css";
import classNames from "classnames";

/**
 *
 * Interactive component that displays a dropdown menu and allows selection
 *
 */

export function Select({
  options,
  onChange,
  placeholder,
  disabled,
  dropdownRight = false,
  className,
  isScrollable,
  onBlur,
}) {
  const [dropdownDisplay, changeDropDownDisplay] = useState(false);

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          changeDropDownDisplay(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  return (
    <div ref={wrapperRef} className={styles.container}>
      <button
        className={classNames(styles.selectDropdown, className)}
        onClick={() => changeDropDownDisplay(!dropdownDisplay)}
        disabled={disabled}
      >
        <span>{placeholder}</span>
        <span className={styles.selectChevron}>
          <ChevronDown fontSize="1.4em" />
        </span>
      </button>
      {dropdownDisplay && (
        <div
          className={classNames(
            dropdownRight ? styles.selectOptionsRight : styles.selectOptions,
            { [styles.scrollable]: isScrollable }
          )}
        >
          {options.map((option) => (
            <button
              className={styles.selectMenuOptions}
              key={option}
              onClick={() => {
                onChange(option);
                changeDropDownDisplay(false);
              }}
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

Select.propTypes = {
  /**
   * Array of the options for the dropdown
   */
  options: PropTypes.array.isRequired,
  /**
   * Function that handles the user changing the option
   */
  onChange: PropTypes.func.isRequired,
  /**
   * String that contains the default value shown in the dropdown
   */
  placeholder: PropTypes.string.isRequired,
  /**
   * Boolean that disables the dropdown
   */
  disabled: PropTypes.bool,
};

Select.defaultProps = {
  disabled: false,
};
